import { render, staticRenderFns } from "./salesTransactions.vue?vue&type=template&id=6c3b3266&"
import script from "./salesTransactions.vue?vue&type=script&lang=js&"
export * from "./salesTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports